import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n  transition: height 0.2s ease-in-out, padding 0.2s ease-in-out;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useLayoutEffect, useRef } from "react";
import styled from "styled-components";
import { Box } from "@miro-site/core";
var StyledContent = styled(Box).withConfig({
    componentId: "sc-a7ce0d86-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.templates.colors.secondary8;
});
var Content = function(_param) {
    var children = _param.children, isExpanded = _param.isExpanded, props = _object_without_properties(_param, [
        "children",
        "isExpanded"
    ]);
    var contentEl = useRef(null);
    useLayoutEffect(function() {
        var current = contentEl.current;
        if (current) {
            var contentHeight = "".concat(current.scrollHeight, "px");
            if (isExpanded) {
                requestAnimationFrame(function() {
                    current.style.height = "0";
                    requestAnimationFrame(function() {
                        current.style.height = contentHeight;
                    });
                });
            } else {
                requestAnimationFrame(function() {
                    current.style.height = "0";
                });
            }
        }
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ _jsx(StyledContent, _object_spread_props(_object_spread({
        ref: contentEl
    }, props), {
        children: children
    }));
};
export default Content;
